import { Component, input } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'app-real-estate-template-info',
  imports: [TranslatePipe],
  templateUrl: './real-estate-template-info.component.html',
  styleUrls: [
    './real-estate-template-info.component.scss',
    '../template-shared.stylesheet.scss',
  ],
})
export class RealEstateTemplateInfoComponent {
  translationPrefix = input('', { transform: appendPrefix });
}
function appendPrefix(value: string | undefined): string {
  return value + 'realEstate.';
}
